// extracted by mini-css-extract-plugin
export var attachment = "_rg-a";
export var emailContainer = "_rg-4";
export var emailContentPaddedContainer = "_rg-b";
export var emailHeader = "_rg-6";
export var emailIframe = "_rg-3";
export var emailInfoIcon = "_rg-9";
export var emailShortenedSummary = "_rg-e";
export var infoDropdown = "_rg-0";
export var infoRowBoundedContent = "_rg-d";
export var internal = "_rg-5";
export var merchant = "_rg-8";
export var messageInputContainer = "_rg-h";
export var normal = "_rg-7";
export var replyCard = "_rg-f";
export var subtleButton = "_rg-1";
export var subtleButtonIconContainer = "_rg-2";
export var toggleViewRepliesButton = "_rg-c";
export var wrappingText = "_rg-g";